export default __webpack_public_path__ + "static/img_0-2c5907b0189fedd0e3fa79b3b0a11211.png";